import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((e) => setError(formatApiError(e)));
  }, [exchangeSession, location.hash, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-obsidian text-white" data-testid="auth-callback">
      {error ? (
        <>
          <p className="text-crimson">{error}</p>
          <button onClick={() => navigate("/admin/login", { replace: true })} className="btn-ghost mt-6">Back to login</button>
        </>
      ) : (
        <Loader2 className="h-6 w-6 animate-spin text-crimson" />
      )}
    </div>
  );
}
